import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ReviewWorkerTimesheetFragment,
  WorkerTimesheetListFragment,
  WorkerTimesheetStatusCountFragment,
} from '@common/graphql/schema';

import { ReviewHourBlock } from './hour-block';

export const WorkerTimesheetList: TypedDocumentNode<WorkerTimesheetListFragment> = gql`
  fragment WorkerTimesheetList on WorksTimekeepingWorkerTimesheet {
    id
    totalSeconds
    status
    canApprove {
      value
    }
    canReject {
      value
    }
    canUnapprove {
      value
    }
    submittedAtTimesheet {
      id
      approvalDeadline
      pastApprovalDeadline
    }
    timesheet {
      id
      startDate
      endDate
      timeZone
    }
    organizationProfiles {
      id
      employeeId
    }
    hourBlocks {
      id
      unit {
        id
        name
      }
    }
    worksMembership {
      id
      name
    }
    hiringLeaders {
      id
      name
    }
  }
`;

export const ReviewWorkerTimesheet: TypedDocumentNode<ReviewWorkerTimesheetFragment> = gql`
  fragment ReviewWorkerTimesheet on WorksTimekeepingWorkerTimesheet {
    id
    totalSeconds
    overtimeThresholdSeconds
    canApprove {
      value
    }
    canReject {
      value
    }
    canUnapprove {
      value
    }
    submittedAtTimesheet {
      id
      pastApprovalDeadline
    }
    canManagerUpsertHours {
      value
    }
    staffingRequestAssignments {
      id
    }
    timesheet {
      id
      startDate
      endDate
      timeZone
    }
    hourBlocks {
      ...ReviewHourBlock
    }
    worksMembership {
      id
      name
    }
    hoursSummary {
      name
      totalSeconds
    }
    status
  }
  ${ReviewHourBlock}
`;

export const WorkerTimesheetStatusCount: TypedDocumentNode<WorkerTimesheetStatusCountFragment> = gql`
  fragment WorkerTimesheetStatusCount on WorksTimekeepingWorkerTimesheetStatusCount {
    id
    name
    value
  }
`;
